export default "__VITE_ASSET__0e796344__"